"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StakedTokenResponse = exports.StakedToken = void 0;
/**
 * Class representing a staked token with methods for instantiation from JSON.
 */
class StakedToken {
    /**
     * Constructs a new StakedToken instance.
     * @param params - Object containing initialization values.
     */
    constructor({ tokenAddress, tokenSymbol, tokenName, tokenLogoURI, stakedAmount, unStakeTokenAddress, stakedAmountUSD, earnedAmountUSD, stakingApr, }) {
        this.tokenAddress = tokenAddress;
        this.tokenSymbol = tokenSymbol;
        this.tokenName = tokenName;
        this.tokenLogoURI = tokenLogoURI;
        this.stakedAmount = stakedAmount;
        this.unStakeTokenAddress = unStakeTokenAddress;
        this.stakedAmountUSD = stakedAmountUSD;
        this.earnedAmountUSD = earnedAmountUSD;
        this.stakingApr = stakingApr;
    }
    /**
     * Creates a StakedToken instance from a JSON object.
     * @param json - JSON object containing staked token details.
     * @returns A new StakedToken instance.
     */
    static fromJson(json) {
        return new StakedToken(json);
    }
}
exports.StakedToken = StakedToken;
/**
 * Class representing a response containing multiple staked tokens.
 */
class StakedTokenResponse {
    /**
     * Constructs a new StakedTokenResponse instance.
     * @param params - Object containing initialization values for the response.
     */
    constructor({ totalStakedAmountUSD, totalEarnedAmountUSD, stakedTokens }) {
        this.totalStakedAmountUSD = totalStakedAmountUSD;
        this.totalEarnedAmountUSD = totalEarnedAmountUSD;
        this.stakedTokens = stakedTokens.map(StakedToken.fromJson);
    }
    /**
     * Creates a StakedTokenResponse instance from a JSON object.
     * @param json - JSON object containing staked tokens response details.
     * @returns A new StakedTokenResponse instance.
     */
    static fromJson(json) {
        return new StakedTokenResponse({
            totalStakedAmountUSD: json.totalStakedAmountUSD,
            totalEarnedAmountUSD: json.totalEarnedAmountUSD,
            stakedTokens: json.stakedTokens.map((tokenJson) => StakedToken.fromJson(tokenJson)),
        });
    }
}
exports.StakedTokenResponse = StakedTokenResponse;
